import videojs from 'video.js';

/* @ts-expect-error ts-migrate(7016) FIXME: Untyped import */
import userAgent from 'js/constants/userAgent';

// patch for including native video subtitles
const supportsNativeTextTracks = () => {
  let supportsTextTracks;
  const Html5 = videojs.getTech('html5');

  // @ts-expect-error TEST_VID is not defined in the type definition but it exists when you access the property
  const html5TestVid = Html5?.TEST_VID;

  if (!html5TestVid || !userAgent.browser) {
    return false;
  }

  supportsTextTracks = !!html5TestVid.textTracks;
  if (supportsTextTracks && html5TestVid.textTracks.length > 0) {
    supportsTextTracks = typeof html5TestVid.textTracks[0].mode !== 'number';
  }
  if (supportsTextTracks && !('onremovetrack' in html5TestVid.textTracks)) {
    supportsTextTracks = false;
  }

  return supportsTextTracks;
};

export default supportsNativeTextTracks;
